/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import config from "../config.json";

const Header = () => {
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about" },
    { label: "Service", href: "/services" },
    { label: "Pricing", href: "/pricing" },
    { label: "Legal Assistance", href: "/legal-assistance" },
    { label: "Contact Us", href: "/contact-us" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-header-green/95 backdrop-blur">
      <div className="container mx-auto px-4">
        {/* Set container height to 120px and vertically center contents */}
        <nav
          className="relative flex h-[90px] items-center justify-between"
          aria-label="Main"
        >
          {/* Left: Logo */}
          <a href="/" className="flex items-center gap-2">
            <img
              src={require("../images/logo.png")}
              alt="Logo"
              className="h-10 w-auto" // adjust as you like; fits well in 120px header
            />
            <span className="sr-only">Home</span>
          </a>

          {/* Center: Desktop Nav */}
          <ul className="pointer-events-auto mb-0 p-0 absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center gap-10 lg:flex">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="text-white text-[16px] font-normal leading-normal hover:text-white/80"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Right: Login (desktop) */}
          <div className="hidden lg:block">
            <a
              href={config.LOGIN_URL}
              className="inline-flex items-center rounded-xl bg-header-button p-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-header-button-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
            >
              User Login
            </a>
          </div>

          {/* Mobile: Burger */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex items-center justify-center rounded-md p-2 text-white/90 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 lg:hidden"
            aria-label="Toggle Menu"
            aria-expanded={open}
          >
            <svg
              className={`h-6 w-6 ${open ? "hidden" : "block"}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
            <svg
              className={`h-6 w-6 ${open ? "block" : "hidden"}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </nav>

        {/* Mobile menu */}
        <div
          className={`lg:hidden transition-[max-height,opacity] duration-300 ease-out ${
            open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          } overflow-hidden`}
        >
          <ul className="flex flex-col gap-2 border-t border-white/10 py-3">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base text-white/90 hover:bg-white/10 hover:text-white"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-1">
              <a
                href={config.LOGIN_URL}
                className="block rounded-lg bg-header-button py-2 px-5 text-base font-medium text-white hover:bg-header-button-hover"
                onClick={() => setOpen(false)}
              >
                User Login
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
